// [auth-mt] Simple functional route guard enforcing authentication
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, Observable, of, switchMap } from 'rxjs';
import { AuthenticationService } from '../services/apps/Authentication/authentication.service';

export const authGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthenticationService);
  const router = inject(Router);

  if (auth.isAuthenticated()) {
    return true;
  }

  // [auth-mt] Try silent refresh if a refresh_token exists
  if (auth.hasRefreshToken()) {
    return auth.refresh().pipe(
      map((ok: boolean) => {
        if (ok) return true;
        return router.createUrlTree(['/authentication/login'], { queryParams: { returnUrl: state.url } });
      })
    );
  }

  return router.createUrlTree(['/authentication/login'], { queryParams: { returnUrl: state.url } });
};
